<template>
	<div id="app">
		<Nav></Nav>
		<div class="main-container">
			<transition mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
window.$ = window.jQuery = require('jquery');

import Nav from '@/components/navigation'
import Foot from '@/components/foot'

export default {
	name: 'App',
	components: {
		Nav,
		Foot
	}
}
</script>

<style lang="scss">
img {
	display: block;
}
* {
	box-sizing: border-box;
}
</style>

<style lang="sass">
@import "stylesheet/base.sass"
@import "stylesheet/reset.css"

#app
.main-container
	padding: 75px 0 0 0
</style>



// WEBPACK FOOTER //
// src/App.vue